import { createAction } from '@reduxjs/toolkit';
import { Balance } from './defaultState';

const setBalance = createAction<Balance>('condition/setBalance');

export default setBalance;
